import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormRadio } from "bm-ui-kit";
import type { FormRadioOptions } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import type { SzechenyiLoanGoal } from "../types";

export const SZECHENYI_LOAN_GOALS: FormRadioOptions<SzechenyiLoanGoal, string> = [
	{ label: "Napi működés biztosítása", value: "DAILY_OPERATION" },
	{
		label: "Forgóeszköz beszerzések / igénybe vett szolgáltatások finanszírozása",
		value: "ACQUISITIONS_FINANCING",
	},
	{ label: "Immateriális javak beszerzése", value: "INTANGIBLE_ACQUISITIONS" },
	{ label: "Ingatlan építése, vásárlása, fejlesztése", value: "PROPERTY_ACTIVITIES" },
	{
		label: "Új vagy használt gép berendezés, egyéb tárgyi eszközök beszerzése",
		value: "STOCK_FINANCING",
	},
	{ label: "Hitelkiváltás", value: "LOAN_REFINANCING" },
	{ label: "Üzletrész/ tulajdonrész vásárlása", value: "COMPANY_ACQUISITION" },
	{ label: "Termőföld vásárlás", value: "LAND_PURCHASE" },
	{ label: "Energiahatékonyság javítása technológiaváltás", value: "EFFICIENCY_UPGRADE" },
];

export interface LoanGoalStepFields {
	loanGoal: SzechenyiLoanGoal;
}

export class LoanGoalStep extends AbstractStep<LoanGoalStepFields> {
	protected renderContent(_values: LoanGoalStepFields, form: FormApi<LoanGoalStepFields>): ReactNode {
		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">Válassz hitelcélt!</Card.Title>
				</Card.Header>
				<Card.Body>
					<FormRadio name="loanGoal" options={SZECHENYI_LOAN_GOALS} variant="button" required />
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "LoanGoalStep";
	}
}
